import HomepageFooter from '@/components/HomepageFooter';
import HomepageHeader from '@/components/HomepageHeader';
import Image from 'next/image';

export default function About() {
  return (
    <div className="min-h-screen bg-[#F6EFED] page-transition">
      {/* Header Component */}
      <HomepageHeader />

      {/* Hero Section with Background */}
      <section className="relative h-[600px] flex items-center">
        {/* Background Image */}
        <div className="absolute inset-0">
          <Image
            src="/about-banner.jpg"
            alt="About Female Fitness Finder"
            fill
            className="object-cover"
            priority
          />
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-[#4C3E581A]" />
        </div>

        {/* Hero Content */}
        <div className="relative z-10 w-full max-w-[1920px] mx-auto h-full flex items-center justify-center absolute bottom-0 left-0 right-0 pt-[180px]">
          <div className="max-w-[842px] text-center">
            <h1 className="font-['Gotham_Rounded',sans-serif] text-[64px] font-bold leading-[76px] tracking-[-4%] text-white mb-10" style={{ marginBottom: '10px' }}>
              About FFF
            </h1>
            <p className="font-['Archivo',sans-serif] text-[20px] font-normal leading-[36px] text-white mb-12 tracking-[3%] max-w-3xl mx-auto" style={{ margin: '0 !important' }}>
              Connecting women with safe, verified, women-only fitness spaces.
            </p>
          </div>
        </div>
      </section>

      {/* First Section - About FFF */}
      <section className="bg-[#f6efed] py-[100px]">
        <div className="max-w-[1320px] mx-auto px-[20px]">
        {/* Story Section - Image Left, Content Right */}
        <div className="grid lg:grid-cols-2 gap-[100px] items-center">
          {/* Left - Image */}
          <div className="relative w-full h-[720px] rounded-[30px] overflow-hidden">
            <Image
              src="/about-fff.jpg"
              alt="Women working out together"
              fill
              className="object-cover"
            />
          </div>
          
          {/* Right - Content */}
          <div className="space-y-6">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-[6px] h-[6px] bg-[#8a7490] rounded-full" />
              <span className="font-['Archivo',sans-serif] text-[16px] font-medium text-[#8a7490] uppercase tracking-wide">About Female Fitness Finder</span>
            </div>
            <h2 className="font-['Gotham_Rounded',sans-serif] text-[48px] font-bold text-[#2E2A3A] leading-[1.2] mb-8">
              Discover women-only, women-led fitness spaces you can trust
            </h2>
            <div className="space-y-6 text-[#6e6672] text-[18px] leading-[40px] font-['Archivo',sans-serif]">
              <p>
                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribute of letter, as opposed to using 'Content here, content here', making it look like readable English.
              </p>
              <p>
                Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years.
              </p>
            </div>
          </div>
        </div>
        </div>
      </section>

      {/* Second Section - Problem We Solve */}
      <section className="bg-white py-[100px]">
        <div className="max-w-[1490px] mx-auto px-[20px]">
        {/* Section Header - Centered */}
        <div className="text-center mb-[60px]">
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="w-[6px] h-[6px] bg-[#8a7490] rounded-full" />
            <span className="font-['Archivo',sans-serif] text-[16px] font-medium text-[#8a7490] uppercase tracking-wide">Problem We Solve</span>
          </div>
          <h2 className="font-['Gotham_Rounded',sans-serif] text-[48px] font-bold text-[#2E2A3A] leading-[56px]">
            Making it easier for women to find safe, <br></br>trusted fitness spaces.
            
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-[100px] items-center">
          {/* Left - Content */}
          <div className="space-y-6">
            <div className="space-y-6 text-[#6e6672] text-[18px] leading-[40px] font-['Archivo',sans-serif]">
              <p>
                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribute of letter, as opposed to using 'Content here, content here', making it look like readable English.
              </p>
              <p>
                Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years.
              </p>
            </div>
          </div>

          {/* Right - Image */}
          <div className="relative w-full h-[580px] rounded-[30px] overflow-hidden">
            <Image
              src="/problem-img.jpg"
              alt="Woman working out with kettlebell"
              fill
              className="object-cover"
            />
          </div>
        </div>
        </div>
      </section>

      {/* Third Section - Mission/Vision */}
      <section className="bg-[#f6efed] py-[100px]">
        <div className="max-w-[1400px] mx-auto px-[20px]">
          <div className="grid lg:grid-cols-2 gap-[100px] items-center">
            {/* Left - Image */}
            <div className="relative w-full h-[720px] rounded-[30px] overflow-hidden">
              <Image
                src="/mission-img.jpg"
                alt="Woman working out"
                fill
                className="object-cover"
              />
            </div>

            {/* Right - Content */}
            <div className="space-y-8">
              <h2 className="font-['Gotham_Rounded',sans-serif] text-[48px] font-bold text-[#2E2A3A] leading-[56px]">
                Our Mission/Vision
              </h2>

              <div className="bg-white rounded-[20px] p-8">
              {/* Mission */}
              <div className="flex gap-6 py-6">
                <div className="flex-shrink-0">
                  <div className="w-[84px] h-[84px] bg-[#8a7490] rounded-full flex items-center justify-center">
                    <Image
                      src="/mission-icon.svg"
                      alt="Mission"
                      width={36}
                      height={36}
                      className="object-contain"
                    />
                  </div>
                </div>
                <div>
                  <h3 className="font-['Gotham_Rounded',sans-serif] text-[30px] font-bold text-[#2E2A3A] mb-3">
                    Our Mission
                  </h3>
                  <p className="font-['Archivo',sans-serif] text-[18px] text-[#6e6672] leading-[28px]">
                    To connect women with fitness spaces designed for them.
                  </p>
                </div>
              </div>

              {/* Separator */}
              <div className="border-t border-gray-200"></div>

              {/* Vision */}
              <div className="flex gap-6 py-6">
                <div className="flex-shrink-0">
                  <div className="w-[84px] h-[84px] bg-[#8a7490] rounded-full flex items-center justify-center">
                    <Image
                      src="/vision-icon.svg"
                      alt="Vision"
                      width={36}
                      height={36}
                      className="object-contain"
                    />
                  </div>
                </div>
                <div>
                  <h3 className="font-['Gotham_Rounded',sans-serif] text-[30px] font-bold text-[#2E2A3A] mb-3">
                    Our Vision
                  </h3>
                  <p className="font-['Archivo',sans-serif] text-[18px] text-[#6e6672] leading-[28px]">
                    A future where every woman can train confidently in a space that prioritises her comfort and safety.
                  </p>
                </div>
              </div>

              {/* Separator */}
              <div className="border-t border-gray-200"></div>

              {/* Value */}
              <div className="flex gap-6 py-6">
                <div className="flex-shrink-0">
                  <div className="w-[84px] h-[84px] bg-[#8a7490] rounded-full flex items-center justify-center">
                    <Image
                      src="/value-icon.svg"
                      alt="Value"
                      width={36}
                      height={36}
                      className="object-contain"
                    />
                  </div>
                </div>
                <div>
                  <h3 className="font-['Gotham_Rounded',sans-serif] text-[30px] font-bold text-[#2E2A3A] mb-3">
                    Our Value
                  </h3>
                  <p className="font-['Archivo',sans-serif] text-[18px] text-[#6e6672] leading-[28px]">
                    Safety. Privacy. Trust. Community.
                  </p>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fourth Section - What Makes Us Different */}
      <section className="bg-white py-[100px]">
        <div className="max-w-[1490px] mx-auto px-[20px]">
          {/* Section Header */}
          <div className="text-center mb-[60px]">
            <h2 className="font-['Gotham_Rounded',sans-serif] text-[48px] font-bold text-[#2E2A3A] leading-[56px] mb-4">
              What Makes Us Different
            </h2>
            <p className="font-['Archivo',sans-serif] text-[18px] text-[#6e6672]">
              Every space on Female Fitness Finder is...
            </p>
          </div>

          {/* Cards Grid */}
          <div className="grid lg:grid-cols-4 gap-8">
            {/* Card 1 - Women-only */}
            <div className="group text-center pt-[70px] pb-[40px] px-[40px] rounded-[20px] transition-all duration-300 hover:bg-[#8A7296]">
              <div className="mb-[70px] flex justify-center h-[80px] items-center">
                <Image
                  src="/women-only-icon.svg"
                  alt="Women-only"
                  width={80}
                  height={80}
                  className="object-contain max-h-[80px] group-hover:brightness-0 group-hover:invert transition-all duration-300"
                />
              </div>
              <h3 className="font-['Gotham_Rounded',sans-serif] text-[24px] font-bold text-[#2E2A3A] group-hover:text-white transition-colors duration-300">
                Women-only
              </h3>
            </div>

            {/* Card 2 - Women-led */}
            <div className="group text-center pt-[70px] pb-[40px] px-[40px] rounded-[20px] transition-all duration-300 hover:bg-[#8A7296]">
              <div className="mb-[70px] flex justify-center h-[80px] items-center">
                <Image
                  src="/women-led-icon.svg"
                  alt="Women-led"
                  width={80}
                  height={80}
                  className="object-contain max-h-[80px] group-hover:brightness-0 group-hover:invert transition-all duration-300"
                />
              </div>
              <h3 className="font-['Gotham_Rounded',sans-serif] text-[24px] font-bold text-[#2E2A3A] group-hover:text-white transition-colors duration-300">
                Women-led
              </h3>
            </div>

            {/* Card 3 - Independently reviewed */}
            <div className="group text-center pt-[70px] pb-[40px] px-[40px] rounded-[20px] transition-all duration-300 hover:bg-[#8A7296]">
              <div className="mb-[70px] flex justify-center h-[80px] items-center">
                <Image
                  src="/reviewed-icon.svg"
                  alt="Independently reviewed"
                  width={80}
                  height={80}
                  className="object-contain max-h-[80px] group-hover:brightness-0 group-hover:invert transition-all duration-300"
                />
              </div>
              <h3 className="font-['Gotham_Rounded',sans-serif] text-[24px] font-bold text-[#2E2A3A] group-hover:text-white transition-colors duration-300">
                Independently reviewed
              </h3>
            </div>

            {/* Card 4 - Designed with safety & privacy in mind */}
            <div className="group text-center pt-[70px] pb-[40px] px-[40px] rounded-[20px] transition-all duration-300 hover:bg-[#8A7296]">
              <div className="mb-[70px] flex justify-center relative h-[80px] items-center">
                <Image
                  src="/safety-icon.svg"
                  alt="Safety & Privacy"
                  width={80}
                  height={80}
                  className="object-contain max-h-[80px] group-hover:opacity-0 transition-all duration-300"
                />
                <Image
                  src="/safety-hover-icon.svg"
                  alt="Safety & Privacy Hover"
                  width={80}
                  height={80}
                  className="object-contain max-h-[80px] absolute top-0 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300"
                />
              </div>
              <h3 className="font-['Gotham_Rounded',sans-serif] text-[24px] font-bold text-[#2E2A3A] group-hover:text-white transition-colors duration-300">
                Designed with safety & privacy in mind
              </h3>
            </div>
          </div>
        </div>
      </section>

      {/* Fifth Section - Our Focus */}
      <section className="bg-[#f6efed] py-[100px]">
        <div className="max-w-[1490px] mx-auto px-[20px]">
          <div className="grid lg:grid-cols-2 gap-[100px] items-center">
            {/* Left - Content */}
            <div className="space-y-6">
              <h2 className="font-['Gotham_Rounded',sans-serif] text-[48px] font-bold text-[#2E2A3A] leading-[56px] mb-8">
                Our focus on women-only, safety and privacy
              </h2>
              <div className="space-y-6 text-[#6e6672] text-[18px] leading-[40px] font-['Archivo',sans-serif]">
                <p>
                  We are not a general fitness directory.
                </p>
                <p>
                  We are a curated platform built specifically for women.
                </p>
                <p>
                  We're here to help you find safe, trusted fitness spaces - or partner with us. Etc etc.
                </p>
              </div>
            </div>

            {/* Right - Image */}
            <div className="relative w-full h-[580px] rounded-[30px] overflow-hidden">
              <Image
                src="/focus-img.jpg"
                alt="Woman working out with kettlebell"
                fill
                className="object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <HomepageFooter />
    </div>
  );
}
